import { useRequest } from "@/shared/composables/useRequest";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService";
import { NotificationsRepository } from "@/app/header/notifications/repositories/NotificationsRepository";
import { NotificationsTotalNotReadModel } from "@/app/header/notifications/models/NotificationsModel";

export function getNotificationsNotReadController() {
  const repository: NotificationsRepository = new NotificationsRepository(new HttpClientService());

  return useRequest<NotificationsTotalNotReadModel>({
    fn: async (userId: string | number) => await repository.getNotificationsNotRead(userId),
    modelClass: NotificationsTotalNotReadModel,
  });
}
